/** Display labels for drivers role codes. */
export const DRIVERS_ROLE_LABELS = {
  c_level: 'C-Level',
  admin: 'Admin',
  hr: 'HR',
  recruiter: 'Recruiter'
};

export const DRIVERS_ROLE_OPTIONS = [
  { value: 'c_level', label: 'C-Level' },
  { value: 'admin', label: 'Admin' },
  { value: 'hr', label: 'HR' },
  { value: 'recruiter', label: 'Recruiter' }
];

export function driversRoleLabel(code) {
  return DRIVERS_ROLE_LABELS[code] || code || '—';
}

export function driversRoleSeverity(code) {
  switch (code) {
    case 'admin':
      return 'danger';
    case 'c_level':
      return 'warn';
    case 'hr':
      return 'info';
    case 'recruiter':
      return 'success';
    default:
      return 'secondary';
  }
}
